import { useParams } from "react-router-dom";
import { Box, CardBody, CardHeader, Divider, VStack } from "@chakra-ui/react";
import { SettingItem } from "../../organisms/SettingItem";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { useFetchKuitanSettingByRestaurantId } from "../../../hooks/kuitan/useFetchKuitanSettingByRestaurantId";
import { RestaurantSettingCardFooter } from "../../organisms/restaurant/RestaurantSettingCardFooter";


export const KuitanSetting = () => {
  const { restaurantId } = useParams();
  const {setting, isLoading} = useFetchKuitanSettingByRestaurantId(restaurantId);
  if (isLoading) return <CircularLoading />;
  const path = setting ? `${setting.id}/edit` : `register`;
  return (
    <DarkShadowCard w='100%'>
      <CardHeader pb={0}>
        <CardHeading icon={<SettingsIcon />} heading='食イタン設定'/>
      </CardHeader>
      <CardBody>
        <VStack spacing={4} fontWeight='bold' fontSize='sm'>
          <Divider m={0} />
          <Box w='100%'>
            <SettingItem label='食べログURL' content={setting?.tabelog_url ?? '未登録'} />
          </Box>
          <Divider m={0} />
        </VStack>
      </CardBody>
      <RestaurantSettingCardFooter path={path} />
    </DarkShadowCard>
  );
};